export const newsType = {
  know: "知識文章",
  news: "焦點新聞",
  notify: "維修公告",
  sharing: "案例分享",
};

export const linkType = {
  INTRANET: "INTRANET",
  EXTERNAL: "EXTERNAL",
};

let ALL_OBJECT = {};

let ALL_NEWS = [
  {
    ID: "ITHOME_251210",
    type: newsType.news,
    src: "news/ithome.jpg",
    time: "2025/12/10",
    title:
      "iThome 專訪｜HiTRUST 利用 AWS 全球基礎建設於多地理區域部署 3-D Secure 驗證架構，宏碁智雲助優化加速海外佈局",
    content:
      "（首圖及內容摘錄自iThome）HiTRUST 利用 AWS 全球基礎建設於多地理區域部署 3-D Secure 網路交易驗證與金流服務，在宏碁智雲協助下完成容器化、監控與成本最佳化，縮短海外專案上線與合規準備時間，讓各國銀行與電商更容易導入安全且穩定的雲端驗證環境。",
    link: {
      type: linkType.EXTERNAL,
      url: "https://www.ithome.com.tw/pr/172508",
    },
  },
  {
    id: "SFF_2025",
    type: newsType.news,
    src: "news/sff_2025.png",
    component: () => import("@/components/Article/SFF2025.vue"),
    time: "2025/12/03",
    title:
      "HiTRUST 再次代表台灣金融科技實力，與 FinTechSpace 一同亮相 SFF 2025！",
    content:
      "今年的 Singapore FinTech Festival（SFF）迎來十週年，作為全球最大的金融科技盛會之一，吸引了來自世界各地的銀行、金融機構與科技創新團隊。SFF 不只是展覽，更是一個專業交流的平台，參展者能透過實體會議、媒合活動與專題分享，快速掌握全球金融科技趨勢，並促成具體合作。",
    link: {
      type: linkType.INTRANET,
      url: "",
    },
  },
  {
    id: "DIGITAL_114",
    type: newsType.sharing,
    src: "news/digital_114.png",
    component: () => import("@/components/Article/Digital.vue"),
    time: "2025/11/24",
    title: "HiTRUST 獲選數發部「114年度數位服務創新補助計畫」",
    content:
      "近日，HiTRUST 成功獲選 數位發展部數位產業署 DIGITAL+ 數位創新補助平台計畫「114年度數位服務創新補助計畫」，在眾多申請方案中脫穎而出，展現政府對 HiTRUST 技術創新與產品價值的高度肯定。",
    link: {
      type: linkType.INTRANET,
      url: "",
    },
  },
  {
    id: "THIRD_PARTY",
    type: newsType.know,
    src: "news/third_party.png",
    component: () => import("@/components/Article/ThirdParty.vue"),
    time: "2025.11.24",
    title: "第三方支付綁定好可怕？真正的風險其實來自「釣魚」與「登入安全」",
    content:
      "近來有許多關於第三方支付遭到盜刷的討論，讓不少使用者擔心：「綁定信用卡&帳戶是不是很危險？」其實，大多數案例的問題並不是第三方支付本身的綁定機制出了問題，而是更上游的環節，民眾的登入帳密在外洩後，被詐騙者用來「正大光明地」登入帳號。",
    link: {
      type: linkType.INTRANET,
      url: "",
    },
  },
  {
    id: "CNA_250924",
    type: newsType.news,
    src: "news/cna_250924.png",
    time: "2025.09.24",
    title: "中央社 CNA 專訪｜靠 AI 即時偵測可疑情境 網際威信防詐拚創新",
    content:
      "（首圖及內容摘錄自中央社）數位經濟蓬勃發展，伴隨著資安風險及詐騙威脅與日俱增。資訊軟體服務公司HiTRUST網際威信7年前成立專責人工智慧（AI）技術團隊，將AI技術導入電商、支付、網銀等場景，不僅解決客戶痛點，也成為放眼全球市場關鍵利基。",
    link: {
      type: linkType.EXTERNAL,
      url: "https://www.cna.com.tw/news/afe/202509240147.aspx?topic=4724",
    },
  },
  {
    id: "INTERVIEW",
    type: newsType.news,
    src: "news/interview.png",
    component: () => import("@/components/Article/Interview.vue"),
    time: "2025/07/18",
    title:
      "《品牌人物誌》HiTRUST 網際威信專訪預告｜每一個品牌背後，都有值得被看見的故事",
    content: `我們用創新，重塑數位安全的想像；用智慧資安，守護每一次信任的交付。<br>這段影片記錄網際威信一路以來的堅持與突破，也讓世界看見，來自台灣的資安品牌，如何走向國際。<br>誠摯邀請您一同收看，見證我們的品牌故事，一起想像信任的數位新未來。`,
    link: {
      type: linkType.INTRANET,
      url: "",
    },
  },
  {
    id: "VERI_ID_25",
    type: newsType.sharing,
    src: "news/veri_id_2025.jpg",
    component: () => import("@/components/Article/VeriId25.vue"),
    time: "2025/06/06",
    title: "Veri-id 獲2025智慧創新大賞金牌｜HiTRUST AI 防詐技術實力獲肯定",
    content: `從來自 36 國、1,253 個團隊的競爭中脫穎而出，HiTRUST「Veri-id 設備識別與 AI即時防詐技術」榮獲經濟部 2025 智慧創新大賞金牌！結合專利設備指紋技術與 AI 行為分析，即時偵測並識別異常的線上操作，有效協助企業防詐、提升資安信任，近期更受邀於 InnoVEX 2025 新創展會分享技術成果。`,
    link: {
      type: linkType.INTRANET,
      url: "",
    },
  },
  {
    id: "LINE_LOGIN_RISK",
    type: newsType.know,
    src: "news/line_login_risk.png",
    component: () => import("@/components/Article/LineLoginRisk.vue"),
    time: "2025/03/18",
    title:
      "「幫投票就被盜」駭客用這招偷走用戶 LINE，你的網站提供第三方登入？小心被拖下水！",
    content: `近期，媒體報導了多起LINE帳號被盜用的案例，不少受害者在通訊軟體收到朋友傳來「可以幫我的寵物投票嗎」與投票連結，進入網頁並登入 LINE 即可投票，沒想到投票後幾個小時，LINE竟被盜用了！`,
    link: {
      type: linkType.INTRANET,
      url: "",
    },
  },
  {
    id: "VERI_ID_FIDO_INTR",
    type: newsType.know,
    src: "news/veri_fido_introduction.jpg",
    component: () => import("@/components/Article/VeriIdFidoIntr.vue"),
    time: "2025/02/10",
    title: "解密 FIDO2 無密碼驗證：企業有什麼好處？該如何導入？",
    content: `你聽過 FIDO2 無密碼驗證嗎？這個身分驗證技術不只是資安界的新寵，更是優化使用者登入體驗的利器。今天，我們將介紹 FIDO2 能為企業帶來的價值，以及如何輕鬆導入 HiTRUSTpay 的 Veri FIDO 解決方案。`,
    link: {
      type: linkType.INTRANET,
      url: "News",
    },
  },
  {
    id: "FIN_TECH_SPACE_24",
    type: newsType.news,
    src: "news/fin_tech_space_2024.jpg",
    time: "2024/11/07",
    title: "為打造亞洲金融科技中心助力 金融科技代表團 赴星國參展",
    content: `為推動台灣金融科技產業與國際市場的接軌，由金管會指導、金融總會規劃設立的一站式金融科技創新加速平台「金融科技創新園區FinTechSpace」第六度率領台灣金融科技代表團，於6日～8日期間參加全球規模最大的金融科技盛會—新加坡金融科技嘉年華。`,
    link: {
      type: linkType.EXTERNAL,
      url: "https://www.ctee.com.tw/news/20241107700112-439901",
    },
  },
  {
    id: "PAREVENT_FRAUD",
    type: newsType.news,
    src: "news/prevent_fraud_with_AI.jpg",
    time: "2024/10/14",
    title: "企業防詐新利器！HiTRUST 結合AI偵測+驗證技術 守護數位安全",
    content: `數位詐騙手法日益複雜，企業面臨的網路威脅不斷，其中密碼登入攻擊首當其衝。面對這樣的挑戰，傳統的機制已不足以抵禦威脅。HiTRUST網威智慧兩大防詐解決方案：1. Veri FIDO無密碼快速驗證服務 2. Veri-id設備識別與AI風險偵測，同時保護企業與用戶。為了對抗數位風險，HiTRUST結合AI偵測與驗證技術，不僅防範密碼漏洞的威脅，還能減輕已外流的資訊對企業與用戶的影響程度。`,
    link: {
      type: linkType.EXTERNAL,
      url: "https://www.accupass.com/event/2409220219552125240836",
    },
  },
  {
    id: "PASSKEY_COLATOUR",
    type: newsType.sharing,
    src: "news/passkey_colatour.jpg",
    time: "2024/09/24",
    title: "HiTRUST將Passkey帶到Colatour Travel",
    content: `來自HiTRUST與台灣領先的旅遊平台Colatour的最新合作。基於近十年的信任夥伴關係，HiTRUST和Colatour攜手推出創新解決方案，使平台實現無密碼化。這一方案依據FIDO聯盟的全球標準，重新定義了數位旅遊預訂平台的安全性。`,
    link: {
      type: linkType.EXTERNAL,
      url: "https://www.facebook.com/HiTRUSTtw/posts/pfbid02DNrMCvtURdLqYcxG5YieXj6vg5fnadg2a6pv8ZHtx1XuhQxWsBdMMQ2ZwDHgfATgl",
    },
  },
  {
    id: "REPORT_PREVENT_FRAUD",
    type: newsType.news,
    src: "news/reports_prevent_fraud_with_AI.png",
    time: "2024/08/20",
    title: "運用AI打擊詐騙 AI領航推動計畫II展現業者智慧防詐方案開發成果",
    content: `AI領航推動計畫自108年迄今通過35件廠商補助案，帶動衍生投資總額累計近新台幣47億元；攜手數產署其他AI實證計畫，舉辦「智慧防詐方案暨案例分享會」。網威智慧開發Veri-id AI 防偽冒詐騙交易安全方案，運用AI偵測分析設備特徵，提前辨識可疑設備及異常行為，目前也已導入電商龍頭及行動支付相關領域。`,
    link: {
      type: linkType.EXTERNAL,
      url: "https://www.bnext.com.tw/article/80202/iii_2024_ai_taiwan",
    },
  },
  {
    id: "SOCIAL_MEDIA_24",
    type: newsType.news,
    src: "news/social_media_2024_AI_Taiwan.png",
    time: "2024/08/16",
    title: "2024 AI Taiwan 「未來AI館」：AI 領航，遇見產業創新未來",
    content: `網威智慧參與AI領航推動計畫，獲得相關輔導資源加速應用創新，成功開發出「設備識別與風險偵測服務」，以設備指紋方式，在使用者還無感過程中，辨識使用者設備資訊，利用AI高效運算的風險評分，即時偵測「登入」或「交易」風險，防止帳戶盜用、社交工程、信用卡盜刷等事件，守護金融機構、電商與消費者安全。`,
    link: {
      type: linkType.EXTERNAL,
      url: "https://www.bnext.com.tw/article/80126/2024aitaiwan.future_ai",
    },
  },
  {
    id: "SOCIAL_MEDIA_REPRT_24",
    type: newsType.news,
    src: "news/social_media_reports_preventFraud_2024.jpg",
    time: "2024/07/30",
    title:
      "反詐新時代！HiTRUST 前進 AI TAIWAN 未來商務展，展現技術實力與創新解方",
    content: `2024《未來商務》再度與 AI TAIWAN 攜手策展，以「AI DRIVING NEW BUSINESS」為主題，匯集國內外頂尖企業與創新技術，致力於展現最完整的 AI 生態系應用，及最全面的新商業解決方案。 HiTRUST 再度以技術領先的姿態，前進 2024 AI TAIWAN 未來商務展，並於「未來 AI 館」展示其最尖端的反詐技術與創新解決方案。`,
    link: {
      type: linkType.EXTERNAL,
      url: "https://www.inside.com.tw/article/35735-HiTRUST?fbclid=IwZXh0bgNhZW0CMTEAAR1x-VR3afkSjk-9fgR1O_dv31b66QZTAJ_9dlnRO0fdyO0mUFemeJCk4N0_aem_y46kEx74H6LGyaRcVsWiuA",
    },
  },
  {
    id: "NETRON",
    type: newsType.news,
    src: "news/with_netron.png",
    time: "2024/07/17",
    title:
      "網路盜刷、數位資安有新解 ! Netron 網創資訊攜手 HiTRUST 網威，打造金融支付雲平台",
    content: `盜刷、詐騙屢見不鮮，2023年台灣發卡機構詐欺通報金額逼近33億，其中超過98%都屬於「非面對面交易」 。網路加速與安全整合服務專家「Netron 網創資訊」與安全電子商務及電子金融服務商「HiTRUST 網際威信」攜手打造的金融支付雲平台，如何運用AI提升網路交易安全性？`,
    link: {
      type: linkType.EXTERNAL,
      url: "https://www.businessweekly.com.tw/business/indep/1004614",
    },
  },
  {
    id: "NO1",
    type: newsType.sharing,
    src: "news/no1.png",
    time: "2024/01/05",
    title: "讓支付變簡單！網際威信HiTRUSTpay市佔第一，為品牌打通順暢金流",
    content: `HiTRUSTpay 憑藉深耕 25 年的產業背景，致力提供一站式金流串接服務，協助中小企業數位轉型、推廣數位支付，為顧客打造智慧安全快速的支付體驗。`,
    link: {
      type: linkType.EXTERNAL,
      url: "https://www.bnext.com.tw/article/77931/hitrust_202312",
    },
  },
];

ALL_NEWS.forEach((item) => {
  ALL_OBJECT[item.id] = item;
});

export function getNewsInsightList() {
  return [
    ALL_OBJECT["THIRD_PARTY"],
    ALL_OBJECT["CNA_250924"],
    ALL_OBJECT["DIGITAL_114"],
  ];
}

export function getAll() {
  return ALL_NEWS;
}

export function getKnow() {
  return ALL_NEWS.filter((item) => item.type === newsType.know);
}

export function getNews() {
  return ALL_NEWS.filter((item) => item.type === newsType.news);
}

export function getNotify() {
  return ALL_NEWS.filter((item) => item.type === newsType.notify);
}

export function getSharing() {
  return ALL_NEWS.filter((item) => item.type === newsType.sharing);
}

export function getNewsRouter() {
  let arr = ALL_NEWS.filter((item) => item.link.type === linkType.INTRANET);
  let router = {
    functionId: "Article",
    component: () => import("@/components/KeepRouter.vue"),
    meta: { setChild: true },
  };

  let children = [];
  arr.forEach((item) => {
    if (item.component != null) {
      // 去除 HTML 標籤並擷取前 150 字作為 SEO Description
      const cleanDesc = (item.content || "")
        .replace(/<[^>]+>/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .substring(0, 150);

      let child = {
        functionId: item.id,
        menuText: item.title,
        component: item.component,
        meta: {
          title: item.title,
          description: cleanDesc
            ? `${cleanDesc}...`
            : "HiTRUST 網威智慧最新消息與產業報導。",
          keywords: `HiTRUST, 網威智慧, ${item.type || "焦點新聞"}, ${
            item.title
          }`,
          priority: "0.7",
          changefreq: "monthly",
        },
      };
      children.push(child);
    }
  });
  router.children = children;
  return router;
}

export function getNewsById(id) {
  return ALL_OBJECT[id];
}
